import { ReactNode } from "react";

import Filters from "components/Filters";
import FiltersSplit from "components/Filters/Split";
import FiltersSidebar from "components/Filters/Sidebar";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import useSearchIntentResourcesOperationsSuggestions from "shared/IntentProject/useSearchIntentResourcesOperationsSuggestions";
import {
  INITIAL_SORT_OPTION,
  INITIAL_SORT_DIRECTION,
  FILTER_TYPE,
  INTENT_PROJECT_RESOURCES_OPERATIONS_SUGGESTIONS_DICTIONARY,
} from "shared/IntentProject/useSearchIntentResourcesOperationsSuggestions/constants";

import { FILTERS_ORDER_SETTINGS_KEY } from "../constants";

type IntentProjectOperationLogFiltersLayoutProps = {
  children: ReactNode;
  intentProjectId: string;
};

const IntentProjectOperationLogFiltersLayout = ({
  children,
  intentProjectId,
}: IntentProjectOperationLogFiltersLayoutProps) => {
  const { filters, filterOptionsMap, loading } =
    useSearchIntentResourcesOperationsSuggestions(intentProjectId);

  return (
    <Filters
      filters={filters}
      filtersItemsOptionsMap={filterOptionsMap}
      filtersLoading={loading}
      sortOptions={[]}
      initialSortOption={INITIAL_SORT_OPTION}
      initialSortDirection={INITIAL_SORT_DIRECTION}
      filtersType={FILTER_TYPE}
      filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
      filtersDictionary={INTENT_PROJECT_RESOURCES_OPERATIONS_SUGGESTIONS_DICTIONARY}
      disableViews
    >
      <FiltersSplit>
        <FiltersSidebar />
        <FiltersContentWrapper>{children}</FiltersContentWrapper>
      </FiltersSplit>
    </Filters>
  );
};

export default IntentProjectOperationLogFiltersLayout;
